.i{justify-content:center;}